import { createFileRoute } from "@tanstack/react-router";
import { WhatIsAgentFramer } from "@/routes/help/what-is-agentframer";

export const Route = createFileRoute("/dashboard/help/what-is-agentframer")({
	component: WhatIsAgentFramer,
});
